"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationContext = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
/**
 * This is used to plumb the validation state from the public API to the
 * places where it's used.
 */
const ValidationContext = (0, _lodestarUtils.createContext)("default", "ValidationContext");
exports.ValidationContext = ValidationContext;
//# sourceMappingURL=ValidationContext.js.map